import { createSystem, defaultConfig, defineConfig, mergeConfigs } from '@chakra-ui/react';
import { buildBaseTheme } from '@invara-dev/react-base';
import { generateCardSlotRecipe } from './componentsnew/cardRecipe';
import { badgeRecipe } from 'src/theme/componentsnew/badgeRecipe.ts';
import { buttonRecipe } from 'src/theme/componentsnew/buttonRecipe.ts';
import { fieldSlotRecipe } from 'src/theme/componentsnew/fieldSlotRecipe.ts';

const baseTheme = buildBaseTheme({
  primaryColor: '#f05a29',
  secondaryColor: '#255993',
  tertiaryColor: '#5AB7E8',
  buttons: {
    borderRadius: 12,
    minWidth: '100px'
  }
});

const frontierTheme = defineConfig({
  globalCss: {
    body: {
      // backgroundColor: 'gray.50'
    },
    html: {
      lineHeight: '1.25'
    },
    '*::selection': {
      bg: 'blue.300'
    }
  },
  theme: {
    slotRecipes: {
      card: generateCardSlotRecipe(),
      field: fieldSlotRecipe
    },
    recipes: {
      badge: badgeRecipe,
      button: buttonRecipe
    },
    tokens: {
      colors: {
        WorkflowGroupActionType: {
          None: { value: '#f8d8d8' },
          Status: { value: '#f8d8d8' },
          Ready: { value: '#d8f8db' },
          Assigned: { value: '#d8eaf8' }
        }
      },
      zIndex: {
        sticky: { value: 900 }
      },
      fonts: {
        heading: { value: `'Montserrat Variable', 'sans-serif'` },
        body: { value: `'Montserrat Variable', 'sans-serif'` }
      }
    }
  }
});

const merged = mergeConfigs(defaultConfig, baseTheme, frontierTheme);
export default createSystem(merged);
